module.exports = __webpack_public_path__ + "static/media/opscore-logo.4609c53e.png";